import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DirectoryStateService {

  private readonly EXPANDED_KEY = 'expandedFolderIds';
  private readonly FOLDER_TAB_STATE_KEY = 'folderTabState';

  private readonly SELECTED_KEY = 'selectedFolderIds';
  private readonly AUTO_SELECT_KEY = 'autoSelectSubfolders';

  saveExpandedFolders(ids: number[]): Observable<void> {
      localStorage.setItem(this.EXPANDED_KEY, JSON.stringify(ids));
      return EMPTY;
    }

    getExpandedFolderIds(): Observable<number[]> {
      const raw = localStorage.getItem(this.EXPANDED_KEY);
      const ids = raw ? JSON.parse(raw) : [];
      return of(ids);
    }

    saveFolderAndTab(folderId: number, tabIndex: number): Observable<void> {
      const state = { folderId, tabIndex };
      localStorage.setItem(this.FOLDER_TAB_STATE_KEY, JSON.stringify(state));
      return EMPTY;
    }

    getFolderAndTab(): Observable<{ folderId: number; tabIndex: number } | null> {
      const raw = localStorage.getItem(this.FOLDER_TAB_STATE_KEY);
      const result = raw ? JSON.parse(raw) : null;
      return of(result);
    }

    saveSelectedFolders(ids: number[]): Observable<void> {
       sessionStorage.setItem(this.SELECTED_KEY, JSON.stringify(ids));
      return EMPTY;
    }

    getSelectedFolderIds(): Observable<number[]> {
      const raw = sessionStorage.getItem(this.SELECTED_KEY);
      return of(raw ? JSON.parse(raw) : []);
    }

    saveAutoSelectSubfolders(enabled: boolean): Observable<void> {
      sessionStorage.setItem(this.AUTO_SELECT_KEY, JSON.stringify(enabled));
      return EMPTY;
    }

    getAutoSelectSubfolders(): Observable<boolean> {
      const raw = sessionStorage.getItem(this.AUTO_SELECT_KEY);
      return of(raw === null ? true : JSON.parse(raw)); 
    }

    clearSelectedFolders(): Observable<void> {
      sessionStorage.removeItem(this.SELECTED_KEY);
      return EMPTY;
    }

  constructor() { }
  }
